module.exports = __webpack_public_path__ + "static/media/malina3.38757920.png";